var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"s-icon-aviso mdi mdi-bell",style:(`color: ${_vm.color}`),on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.clicked.apply(null, arguments)},"click":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }